<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("Reason", 2) }}
      </div>
      <router-link class="btn-blue" to="stocktakereasons"
        >{{ $tc("Stock Take", 2) }} {{ $tc("Reasons list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-lg-6 col-xl-3 ">
            <b-form-group>
              <div class="input-material mt-2">
                <b-form-input
                  id="reasonName"
                  v-model="reasonList.reason_name"
                  placeholder="Enter Your Reason"
                  type="text"
                ></b-form-input>
                <label>Enter Your Reason</label>
              </div>
            </b-form-group>
            <label v-if="error.reason_name_error" style="color:red !important;"
              >Reason Name is required</label
            >

            <!-- <Tooltip :title="$t(item.tooltip)" /> -->
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center">
            <b-form-checkbox
              v-model="reasonList.reason_is_active"
              class="j-checkbox ml-3 mb-3"
              unchecked-value="N"
              value="Y"
            >
              Is Active
            </b-form-checkbox>
            <!-- <label style="color:red !important;" v-if="error.isActive_error_msg">isActive is required</label> -->
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              class="btn-blue"
              @click.prevent.stop="onStockReasonFinalSubmit()"
            >
              <!-- @click.prevent.stop="onFinalSubmit(true)" -->
              {{ $t("save") }}
            </button>
            <!-- <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button> -->

            <b-button
              class="btn-outline-grey"
              variant="default"
              to="stock-take-reasons"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import ExhibitorService from "@/services/ExhibitorService";
  const dropdownvalidation = ["country_id"];

  export default {
    data() {
      return {
        StockReasonData: [],
        editMode: false,
        reasonList: {
          reason_id: "",
          reason_name: "",
          reason_is_active: false,
        },
        error: {
          reason_name_error: false,
        },
        btenable: false,
      };
    },
    beforeMount() {
      console.log(this.$route.query, "this.$route.query");
      if (this.$route.query.reason_id) {
        this.editMode = true;
        this.reasonList.reason_id = this.$route.query.reason_id;
        this.getStockReasonData();
      }
    },
    mounted() {},
    methods: {
      validateData() {
        if (!this.reasonList.reason_name) {
          this.error.reason_name_error = true;
          return false;
        } else {
          this.error.reason_name_error = false;
        }

        // Verification Done!
        return true;
      },

      onStockReasonFinalSubmit() {
        if (this.validateData()) {
          let loader = this.$loading.show();
          let payload = {
            reason_id: this.editMode ? this.reasonList.reason_id : undefined,
            reason_name: this.reasonList.reason_name,
            reason_is_active: this.reasonList.reason_is_active,
          };
          //console.log(payload);
          ExhibitorService.AddStockReason(payload)
            .then((response) => {
              const { data } = response;
              this.$toasted.show(data.message);
              this.$router.go(-1);
            })
            .catch((err) => {
              //console.log(err);
            })
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        } else {
          console.error("Validation Error");
        }
      },

      getStockReasonData() {
        // this.pp_type_id = item.pp_type_id;
        // this.is_active = item.is_active;
        let payload = {
          reason_id: this.editMode ? this.reasonList.reason_id : undefined,
          // is_active: this.is_active,
        };
        ExhibitorService.GetStockReasonData(payload)
          .then((response) => {
            const { data } = response;

            if (data.Records.length > 0) {
              // console.log(data.Records);
              let StockReasonData = data.Records;
              this.StockReasonData = StockReasonData;
              this.reasonList.reason_name = this.StockReasonData[0].reason_name;
              this.reasonList.reason_is_active = this.StockReasonData[0].reason_is_active;
            } else {
              this.StockReasonData = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/editstocktakereasons.vue